const EPSILON = 1e-12;

const finiteNumberAt = (values: unknown, index: number): number | null => {
  if (!Array.isArray(values)) return null;
  const value = Number(values[index]);
  return Number.isFinite(value) ? value : null;
};

/**
 * MuJoCo general actuators with affine bias commonly implement a position servo:
 * force = gainprm[0] * ctrl + biasprm[1] * q + biasprm[2] * qvel.
 * At zero velocity/equilibrium, the control needed to hold q is q * -biasprm[1] / gainprm[0].
 */
export const mapAffinePositionTargetToControl = (
  positionTarget: number,
  gainprm?: unknown,
  biasprm?: unknown
): number => {
  const target = Number(positionTarget);
  if (!Number.isFinite(target)) return target;

  const gain = finiteNumberAt(gainprm, 0);
  const positionBias = finiteNumberAt(biasprm, 1);
  if (gain == null || positionBias == null || Math.abs(gain) <= EPSILON) {
    return target;
  }

  const control = target * (-positionBias / gain);
  return Number.isFinite(control) ? control : target;
};
